module.exports = __webpack_public_path__ + "fonts/Montserrat-italic_5e536deeb32cba2bb01767aa74d8c66f.ttf";